<div class="bg-overlay" [ngClass]="{'-type-half-angled': isHalfAngled}"></div>